/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { errorResponseSchema } from "./errorResponseSchema.ts";
import { resendOTPRequestRequestSchema } from "./resendOTPRequestRequestSchema.ts";
import { verifyMethodSchema } from "./verifyMethodSchema.ts";

export const userCheckPhoneResendCreateStatus200Schema = verifyMethodSchema.describe("Сериализатор ответа успешной отправки ОТП-кода.");

export const userCheckPhoneResendCreateStatus400Schema = errorResponseSchema;

export const userCheckPhoneResendCreateStatus503Schema = errorResponseSchema;

export const userCheckPhoneResendCreateResponseSchema = z.union([
	userCheckPhoneResendCreateStatus200Schema,
	userCheckPhoneResendCreateStatus400Schema,
	userCheckPhoneResendCreateStatus503Schema,
]);

export const userCheckPhoneResendCreateDataSchemaJson = resendOTPRequestRequestSchema;

export const userCheckPhoneResendCreateDataSchemaXml = resendOTPRequestRequestSchema;

export const userCheckPhoneResendCreateDataSchema = z.union([userCheckPhoneResendCreateDataSchemaJson, userCheckPhoneResendCreateDataSchemaXml]);
